import { Link } from "react-router-dom";
import { GithubLogo, LinkedinLogo } from "@phosphor-icons/react";

import "./footer.scss";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="page footer-inner">
        <div className="socials">
          <a href="https://www.linkedin.com/in/kareemelewa/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <LinkedinLogo size={22} weight="light" />
          </a>
          <a href="https://github.com/kareemxyz" target="_blank" rel="noreferrer" aria-label="GitHub">
            <GithubLogo size={22} weight="light" />
          </a>
        </div>
        <Link className="rally-teaser" to="/play">Wanna rally?</Link>
        <p className="footer-note">Designed and built by Kareem Elewa</p>
      </div>
    </footer>
  );
}
